import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    paymentCards: [],
    webToken: '',
    paymentMethodAdded: false,
    loading: false,
    error: false,
    errorMessage: '',
};

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setPaymentCards(state, action) {
            state.paymentCards = action.payload;
        },
        setWebToken(state, action) {
            state.webToken = action.payload;
        },
        clearWebToken(state, action) {
            state.webToken = '';
        },
        setPaymentMethodAdded(state) {
            state.paymentMethodAdded = true;
        },
        clearPaymentMethodAdded(state) {
            state.paymentMethodAdded = false;
        },
        setLoading(state, action) {
            const { isLoading, willClearError } = action.payload;

            if (willClearError) {
                state.error = false;
                state.errorMessage = '';
            }
            state.loading = isLoading;
        },
        setError(state, action) {
            state.loading = false;
            state.error = true;
            state.errorMessage = action.payload;
        },
        clearError(state, action) {
            state.error = action.payload;
            state.errorMessage = '';
        },
    },
});

export const paymentActions = paymentSlice.actions;
export default paymentSlice;
